import { Component, computed, OnInit, signal, Signal } from '@angular/core';
import { MatGridListModule } from '@angular/material/grid-list';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';
import { WebsiteStateService } from '../../../../state-management/services/website-state.service';
import { BusinessConfiguration, Review } from '../../../../state-management/model/interfaces/state.model';
import { ScreensizeStateService } from '../../../../state-management/services/screensize-state.service';
import { CoordinatesSystem, ScreenWidthBreakpoints } from '../../../../state-management/model/enums/screen-size.enums';
import { DEFAULT_GOOGLE_REVIEW_USER_IMAGE } from '../../../../state-management/constants/global.constants';
import { MatIconModule } from '@angular/material/icon';
import { AnalyticsService } from '../../../../services/analytics.service';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'base-app-reviews',
  imports: [
    MatGridListModule,
    CommonModule,
    MatButtonModule,
    RouterModule,
    MatIconModule
  ],
  templateUrl: './base-reviews.component.html',
  styleUrl: './base-reviews.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class BaseReviewsComponent implements OnInit {
  public isSmallScreen$: Signal<boolean> = this.screensizeState.isScreenSizes(CoordinatesSystem.ScreenWidth, [ScreenWidthBreakpoints.Small, ScreenWidthBreakpoints.XSmall]);
  public metaData: Signal<BusinessConfiguration> = this.websiteState.configuration;
  public GRLink: string = this.websiteState.googleReviewLink();
  public isAdminPage = environment.isAdminPage;
  
  // TODO: _isCookiePolicyAccepted$ is currently not initialized in admin mode. Fix this properly.
  public ccAccepted$: Signal<boolean> = this.isAdminPage ? signal<boolean>(true) : this.websiteState.ccAccepted;
  
  
  constructor(
    private websiteState: WebsiteStateService,
    private screensizeState: ScreensizeStateService,
    private analyticsService: AnalyticsService
  ) { }

  ngOnInit() { }

  public useDefaultImage(event: Event) {
    const imgElement = event.target as HTMLImageElement;
    imgElement.src = DEFAULT_GOOGLE_REVIEW_USER_IMAGE;
  }

  getFilteredReviews(): Signal<Review[]> {
    return computed(() => {
      return this.metaData().reviews
        .filter(review => review.show) // Filtert nach 'show'
        .sort((a, b) => {
          if (a.websitePosition === null) return 1; // Reviews mit 'null' nach hinten schieben
          if (b.websitePosition === null) return -1; // Reviews mit 'null' nach hinten schieben
          return a.websitePosition - b.websitePosition; // Sortierung nach 'websitePosition'
        });
    });
  }

  public trackReviewClick() {
    this.analyticsService.trackClick('review_click');
  }

}